import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0257821b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-to-partner-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "Review completed requests", -1))
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartnerRequestListItem = _resolveComponent("PartnerRequestListItem")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createVNode(_component_white_box_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.reviewRequest.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No Data"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewRequest, (data, index) => {
              return (_openBlock(), _createBlock(_component_PartnerRequestListItem, {
                key: data.id,
                data: data,
                index: index + 1
              }, null, 8, ["data", "index"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}